import ImageButton from './_image-button.js'
import ShareDialog from './_share-dialog.js'
import Hideable from './_hideable.js'

export default {
  name: 'ShareBet',
  values: {
    maximumNumberOfSelections: 6,
    showShareButtonLabel: false,
    shareButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              minHeight: '40px',
              minWidth: '40px',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexGrow: '0',
            },
          },
        },
        buttonIcon: {
          src: 'share',
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
        innerContainer: {
          itemSpacing: '8px',
          style: {
            flexDirection: 'row',
            justifyContent: 'center',
          },
        },
      },
    },
    dialog: {
      configSet: ShareDialog,
      configValues: {},
    },
    $mixin: [
      {
        configSet: Hideable,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
